import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

declare let delta: any;

@Component({
  selector: 'ngc-make-correction',
  templateUrl: 'make-correction.component.html'
})
export class MakeCorrectionComponent implements OnDestroy {
  @Input() formGroupToValidate: UntypedFormGroup;
  @Input() numberOfErrors = 0;
  @Input() focusableFieldName: any;
  onMakeCorrectionClickedEvent: EventEmitter<any> = new EventEmitter();
  public timeouts = [];

  constructor(private elementRef: ElementRef) {}

  makeCorrectionClicked() {
    this.onMakeCorrectionClickedEvent.emit(this.focusableFieldName);
    // if (this.focusableFieldName !== null) {
    //   this.focusableFieldName.focus();
    // }
  }

  requestFocus() {
    if (this.elementRef) {
      this.timeouts.push(
        setTimeout(() => {
          const firstElementChild =
            this.elementRef.nativeElement.firstElementChild;
          if (firstElementChild) {
            firstElementChild.focus();
          }
        }, 200)
      );
    }
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  ngOnDestroy() {
    this.stopTimeout();
  }
}
